import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { OptionsBreakdown } from 'src/components/molecules/PriceBreakdown/PriceBreakdown';
import type { SelectedOptionValuesRecord } from 'src/redux/basket/types';
import { getOptionAmount } from 'src/utils/price';

export const getOptionsBreakdown = (
  personalisations: SelectedOptionValuesRecord,
  currency: CurrencyCode,
): OptionsBreakdown => {
  const defaults = { amountAdded: 0, amountRemoved: 0 };

  return Object.values(personalisations).reduce((totalBreakdown, optionSelection) => {
    const currentBreakdown = optionSelection!.reduce(({ amountAdded, amountRemoved }, opt) => {
      const { isNegative, value } = getOptionAmount(currency, opt.priceModifier);

      return {
        amountAdded: isNegative ? amountAdded : amountAdded + value,
        amountRemoved: isNegative ? amountRemoved + value : amountRemoved,
      };
    }, defaults);

    return {
      amountAdded: totalBreakdown.amountAdded + currentBreakdown.amountAdded,
      amountRemoved: totalBreakdown.amountRemoved + currentBreakdown.amountRemoved,
    };
  }, defaults);
};
